import { MasterQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig/models";

import * as questionIds from "./mhpTreatmentReportQuestionIds";

export const mhpTreatmentReportMasterConfig: MasterQuestionConfig[] = [
    // Employee Details
    {
        id: questionIds.EmployeeId,
        questionText: "",
        canBeDisabled: false
    },
    {
        id: questionIds.EmployerAndDivision,
        questionText: "",
        canBeDisabled: false
    },
    {
        id: questionIds.DateOfBirth,
        questionText: "Date of Birth",
        canBeDisabled: false
    },
    {
        id: questionIds.PersonalReferenceNumber,
        questionText: "Personal reference number",
        canBeDisabled: false
    },
    {
        id: questionIds.EmployeeUniqueID,
        questionText: "Employee Unique Id",
        canBeDisabled: false
    },
    {
        id: questionIds.JobRole,
        questionText: "Job Role",
        canBeDisabled: false
    },
    {
        id: questionIds.HrManager,
        questionText: "HR / Manager",
        canBeDisabled: false
    },
    {
        id: questionIds.Worksite,
        questionText: "Worksite",
        canBeDisabled: false
    },
    {
        id: questionIds.DateMethod,
        questionText: "Date & Method",
        canBeDisabled: false
    },

    // Referral Details
    {
        id: questionIds.ReasonForReferral,
        questionText: "Reason for referral",
        canBeDisabled: false
    },
    {
        id: questionIds.Diagnosis,
        questionText: "Diagnosis",
        canBeDisabled: false
    },
    {
        id: questionIds.NumberOfSessions,
        questionText: "Number of sessions (including initial assessment)",
        canBeDisabled: false
    },
    {
        id: questionIds.IntroductionAndDataPrivacyConsultationMethod,
        questionText: "",
        canBeDisabled: false
    },

    // Treatment Received
    {
        id: questionIds.TreatmentReceivedAnswers,
        questionText: "",
        canBeDisabled: false
    },

    // Outcome
    {
        id: questionIds.OutcomeAnswers,
        questionText: "",
        canBeDisabled: false
    },

    // Work Status
    {
        id: questionIds.WorkStatusAtInitialAssessment,
        questionText: "At Initial Assessment",
        canBeDisabled: false
    },
    {
        id: questionIds.WorkStatusAtDischarge,
        questionText: "At Discharge",
        canBeDisabled: false
    },

    // Questionnaire Scores
    {
        id: questionIds.QuestionnaireScoresAtInitialAssessmentPHQ9,
        questionText: "PHQ9 (At Initial Assessment)",
        canBeDisabled: false
    },
    {
        id: questionIds.QuestionnaireScoresAtInitialAssessmentGAD7,
        questionText: "GAD7 (At Initial Assessment)",
        canBeDisabled: false
    },
    {
        id: questionIds.QuestionnaireScoresAtInitialAssessmentWSAS,
        questionText: "WSAS (At Initial Assessment)",
        canBeDisabled: false
    },
    {
        id: questionIds.QuestionnaireScoresAtDischargePHQ9,
        questionText: "PHQ9 (At Discharge)",
        canBeDisabled: false
    },
    {
        id: questionIds.QuestionnaireScoresAtDischargeGAD7,
        questionText: "GAD7 (At Discharge)",
        canBeDisabled: false
    },
    {
        id: questionIds.QuestionnaireScoresAtDischargeWSAS,
        questionText: "WSAS (At Discharge)",
        canBeDisabled: false
    },

    // Further Adjustments/Recommendations
    {
        id: questionIds.FurtherAdjustmentsRecommendationsComments,
        questionText: "Further Adjustments/Recommendations",
        canBeDisabled: false
    }
];
